export const version = '1.0.8';
export const build = ':1fff46b';
export const buildTime = '1790261823349';
